/**
 * Marker cookie for the Spond app's embedded web view.
 *
 * The apps append `?embedded_in_app=ios|android` to the entry URL. Middleware
 * sets this session cookie on that first request and EmbeddedInAppUrlCleanup
 * strips the param client-side, so later in-tab navigations stay in embedded
 * mode without leaking the marker into shareable URLs. Only the browser reads
 * it (src/lib/embeddedInAppBootstrap.ts): the HTML is shared through a cache.
 *
 * To smoke-test in a browser, visit any URL with `?embedded_in_app=ios`.
 *
 * Kept free of `next/headers` so middleware (Edge) and client code can import it.
 */
export const EMBEDDED_IN_APP_COOKIE = "embedded_in_app";

/**
 * Set by /auth/sso, so it exists only in a web view whose app hands over a
 * session. App versions that open Discover without a session-transfer code
 * never get it, and the signup funnel shows its sign-in form to them instead
 * of the continue-in-app state.
 */
export const EMBEDDED_SESSION_TRANSFER_COOKIE = "embedded_session_transfer";

/**
 * A session-scoped `name=true` flag the bootstrap script reads before paint,
 * so it is script-readable on purpose: a UI mode flag, not a credential.
 */
export function embeddedFlagCookie(name: string) {
  return {
    name,
    value: "true",
    httpOnly: false,
    path: process.env.NEXT_PUBLIC_BASE_PATH?.trim() || "/",
    secure: process.env.NODE_ENV === "production",
    sameSite: "lax" as const,
  };
}
